import React from 'react';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import { SEOProps } from './seo-types';

export const SEO = ({
  title = '',
  description = 'Show you care from anywhere with your handwritten message printed on a Hallmark card and mailed for you. Shop cards for birthdays, holidays, and any day.',
  itemProps = [],
  metaProperties = [],
  links = [],
  robots = 'noindex',
  jsonLinkedData,
}: SEOProps): React.ReactElement => {
  return (
    <HelmetProvider>
      <Helmet>
        <title>{title ? title : 'Hallmark US'} </title>
        <meta name="description" content={description} />
        {itemProps?.map(({ name, content }) => (
          <meta key={name} itemProp={name} content={content} />
        ))}
        {metaProperties?.map(({ property, content }) => (
          <meta key={property} property={property} content={content} />
        ))}
        {links?.map(({ rel, href }) => (
          <link key={rel} rel={rel} href={href} />
        ))}
        {robots && <meta name="robots" content={robots} />}
        {jsonLinkedData && <script type="application/ld+json">{jsonLinkedData}</script>}
      </Helmet>
    </HelmetProvider>
  );
};
